module.exports = __webpack_public_path__ + "media/images/1943-8a26ef237bf94511234104d046a217a4.png";